import type { PaRoutine } from '@easyflow/shared';

export function appendRoutineChatDraft(draft: string, routine?: PaRoutine): string {
  const request = routine
    ? `Vorrei modificare la mia routine "${routine.title}" (ID routine: ${routine.id}). `
    : 'Vorrei creare una nuova routine: ';
  return draft.trim() ? `${draft}\n\n${request}` : request;
}